export var SwitchType;
(function (SwitchType) {
    SwitchType[SwitchType["Bit"] = 0] = "Bit";
    SwitchType[SwitchType["Word"] = 1] = "Word";
})(SwitchType || (SwitchType = {}));
